import { setSelectedElementUuidsAction } from 'editor/src/store/editor/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const removeAllSelectedMediaElementsOperation = () => (dispatch: ThunkDispatch) => {
  dispatch(setSelectedElementUuidsAction([]));
};

export default removeAllSelectedMediaElementsOperation;
